module.exports={
	"Hash": "plansheet-paper",
	"Name": "Drafting Paper",
	"Version": "1.0.0",
	"Description": "White sheet, Staedtler cobalt, ink linework, and a faint non-photo blue cast in the furniture. The daylight drafting table. A light theme in every light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#F6F7F9",
				"Secondary": "#EEF1F4",
				"Tertiary":  "#E4E9EF",
				"Panel":     "#FFFFFF",
				"Hover":     "#E9EDF2",
				"Selected":  "#DCE8F7"
			},
			"Text": {
				"Primary":     "#161A1F",
				"Secondary":   "#3E4650",
				"Muted":       "#5A6470",
				"Placeholder": "#9AA3AE"
			},
			"Brand": {
				"Primary":      "#0A4F9E",
				"PrimaryHover": "#093F80",
				"Accent":       "#B07F0C"
			},
			"Border": {
				"Default": "#CBD3DD",
				"Light":   "#DFE4EA",
				"Strong":  "#9AA6B4"
			},
			"Status": {
				"Success": "#2F7A3C",
				"Warning": "#B07F0C",
				"Error":   "#B23A2E",
				"Info":    "#0A4F9E"
			},
			"Scrollbar": {
				"Track": "#E7EBF0",
				"Thumb": "#C2CBD6",
				"Hover": "#9AA6B4"
			},
			"Selection": {
				"Background": "#C7DCF5",
				"Text":       "#161A1F"
			},
			"Focus": {
				"Outline": "#0A4F9E"
			},
			"Shadow": {
				"Color": "rgba(16, 26, 38, 0.12)"
			},
			"Syntax": {
				"Keyword":     "#8A4FA0",
				"String":      "#3E7E3E",
				"Number":      "#8A5A00",
				"Comment":     "#9AA3AE",
				"Operator":    "#0A4F9E",
				"Punctuation": "#3E4650",
				"Function":    "#0A4F9E",
				"Variable":    "#161A1F",
				"Type":        "#8A5A00",
				"Builtin":     "#8A5A00",
				"Property":    "#B23A2E",
				"Tag":         "#B23A2E",
				"AttrName":    "#8A5A00",
				"AttrValue":   "#3E7E3E"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
				"Display": "'Gorton Perfected', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Display": {
				"Transform": "uppercase",
				"Tracking": "1.5px",
				"Weight": "700"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
